<!--
 * @Author: Smart
 * @Date: 2022-01-19 16:01:07
 * @LastEditTime: 2024-07-09 10:46:18
 * @LastEditors: dyl
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/index.vue
-->
<template>
  <section>
    <wn-template
      :list-query.sync="listQuery"
      :search-key-info="searchKeyInfo"
      :show-table-check-list.sync="showTableCheckList"
      @fetchData="getDataList(listQuery)"
    >
      <!-- @tab-click="changePages" -->
      <div slot="funBtn" class="flex mt-10">
        <div class="button-container">
          <w-button size="small" type="primary" @click="patchPlan()">
            下发整改
          </w-button>
          <!-- <w-button size="small" type="primary" @click="patchPlanBack()">
            下发撤回
          </w-button> -->
        </div>
      </div>
      <w-table
        ref="table"
        v-win-loading="tableloading"
        :data="tableData"
        highlight-current-row
        border
        style="width: 100%; margin-top: 8px"
        stripe
        height="calc(100vh - 150px)"
      >
        <w-table-column
          type="selection"
          width="50"
          :selectable="selectable"
        ></w-table-column>
        <w-table-column type="index" label="序号" width="65" align="center">
          <template slot-scope="scope">
            {{
              listQuery.PageSize * (listQuery.PageIndex - 1) + scope.$index + 1
            }}
          </template>
        </w-table-column>
        <w-table-column
          v-for="co in tableColumns"
          :key="co.key"
          :prop="co.key"
          :label="co.name"
          :align="co.align"
          :width="co.width"
          :min-width="co.minWidth"
          :show-tooltip-overflow="true"
        >
          <template slot-scope="scope">
            <span v-if="co.key === 'JCSJ'">
              {{ scope.row.JCSJ ? scope.row.JCSJ.split(' ')[0] : '' }}
            </span>
            <span v-else-if="co.key === 'TJZT'">
              {{ scope.row.TJZT === '1' ? '待整改' : '未下发' }}
            </span>
            <span v-else>
              {{ scope.row[co.key] }}
            </span>
          </template>
        </w-table-column>
        <w-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="scope">
            <template>
              <w-button
                type="text"
                :disabled="
                  scope.row.TJZT === '1' ||
                  (scope.row.SFDJ == 1 && scope.row.XFDJZT == 1)
                "
                :class="scope.row.SFDJ == 1 ? 'red-botton' : ''"
                @click.native.stop="patchPlan(scope.row)"
                >{{ scope.row.SFDJ === 1 ? '下发申请' : '下发' }}</w-button
              >
              <w-button
                type="text"
                :disabled="scope.row.SFCH == 1 || scope.row.TJZT !== '1'"
                @click.native.stop="patchPlanBack(scope.row)"
              >
                撤回
              </w-button>
              <w-button
                type="text"
                :disabled="
                  scope.row.SFCH == 1 ||
                  scope.row.TJZT === '1' ||
                  scope.row.TJZT === null
                "
                @click.native.stop="deletePlan(scope.row)"
                >删除</w-button
              >
              <w-button
                type="text"
                :disabled="!scope.row.XFXH"
                @click.native.stop="reviewPlan(scope.row)"
                >查看</w-button
              >
            </template>
          </template>
        </w-table-column>
      </w-table>
    </wn-template>
    <detail-dialog
      v-if="detailVisible"
      class="detailVisible"
      :dialog-visible="detailVisible"
      :dialog-close="dialogClose"
      :selected-arr="selectArr"
      :zkjb="Zkjb"
      :hospitalCode="HospitalCode"
      :is-review="isReview"
    ></detail-dialog>
  </section>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import { pageSizes } from '@/common/settings/pageSettings'
import WnTemplate from '@/common/components/WnTemplate'
import moment from 'moment'
import ApplyDialog from '@/common/components/Dialog/ApplyDialog.vue'
import detailDialog from '@/apps/modules/qc-qualityImprovement/rectification/_components/dialog/detailDialog.vue'

export default {
  name: 'QualityImprovementDialog',
  components: { WnTemplate, detailDialog },
  props: {
    cfxh: {
      type: String,
      default: ''
    },
    Zkjb: {
      type: [String],
      default: () => {
        return null
      }
    },
    HospitalCode:{
        type: String,
        default: ''
    }
  },
  data() {
    return {
      applyDataXf: {},
      detailVisible: false,
      isReview: false,
      selectArr: [],
      UserInfo: {},
      pageSizes: pageSizes,
      PageSize: 20,
      PageIndex: 1,
      config: {
        select: false
      },
      tableColumns: [
        {
          name: '检查日期',
          key: 'JCSJ',
          width: '110',
          align: 'center',
          keepChoosing: true,
          checked: true
        },
        {
          name: '受检科室',
          key: 'KSMC',
          width: '120',
          align: 'left',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          minWidth: '200',
          align: 'left',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          align: 'left',
          minWidth: '200',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'KFYYSM',
          minWidth: '200',
          align: 'left',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分',
          key: 'KFJG',
          width: '80',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查者',
          key: 'ZZMC',
          width: '200',
          align: 'left',
          keepChoosing: false,
          checked: true
        },
        {
          name: '其他检查者',
          key: 'ZYMC',
          width: '200',
          align: 'left',
          keepChoosing: false,
          checked: true
        },
        {
          name: '整改类型',
          key: 'ZGLX',
          width: '100',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '整改状态',
          key: 'TJZT',
          width: '100',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '整改要点',
          key: 'ZGYD',
          width: '160',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '接收人',
          key: 'JSR_MC',
          width: '160',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '责任人',
          key: 'ZRRMC',
          width: '120',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '备注',
          key: 'MEMO',
          width: '120',
          align: 'center',
          keepChoosing: false,
          checked: true
        }
      ],
      showTableCheckList: [],
      tableData: [],
      currentRow: null,
      listQuery: {
        PageIndex: 1,
        PageSize: 15,
        total: 0,
        Cfxh: null
      },
      filterQueryList: [],
      searchKeyInfo: {
        name: '', // searchKey-名称
        onlySearch: true,
        hide: false
      },
      tableloading: false
    }
  },
  computed: {
    ...mapGetters(['systemParam']),
    ...mapState('rectification', [''])
  },
  watch: {},
  created() {
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.GetSxkzList()
    this.toggleShow(this.systemParam.wdType)
    this.getDataList()
  },
  methods: {
    ...mapMutations('plan', ['SET_ISREFRESH_TABLE']),
    GetSxkzList() {
      this.$requestApi('GetSxkzList', {}).then((res) => {
        if (res.success) {
          this.applyDataXf = res.data.DataList.find((i) => i.CJDM == 'JCWTXF')
        } else {
          this.$msg(res.message)
        }
      })
    },
    toggleShow(type) {
      // 3表单 4项目 5标准 6扣分标准
      switch (type) {
        case '10': //扣分
          break
        case '20': //标准
          this.tableColumns.splice(5, 1)
          break
        case '30': //项目
          this.tableColumns.splice(5, 1)
          this.tableColumns.splice(4, 1)
          break
        case '40': // 表单
          this.tableColumns.splice(5, 1)
          this.tableColumns.splice(4, 1)
          this.tableColumns.splice(3, 1)
          break
      }
    },
    dialogClose() {
      this.detailVisible = false
      this.getDataList()
    },
    selectable(row) {
      return row.TJZT !== '1' && row.SFDJ !== 1
    },
    handleCurrentChange(val) {
      this.currentRow = val
    },
    // 获取质量改进计划列表
    getDataList() {
      let obj = {
        Cfxh: this.cfxh,
        workStationQuery: true
      }
      this.tableloading = true
      this.$requestApi('GetImprovePlanList', obj)
        .then((res) => {
          this.tableloading = false

          if (res.success) {
            this.tableData = res.data
            this.listQuery.total = res.total
          }
        })
        .catch((err) => {
          this.loading = false
        })
    },
    formatDate(val) {
      return moment(val).format('YYYY-MM-DD')
    },
    deletePlan(row) {
      this.$Confirm('确定删除该问题吗? ', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          let params = [
            {
              Cfxh: row.CFXH,
              Xfxh: row.XFXH,
              Kfxdm: row.KFXDM
            }
          ]
          this.$requestApi('DeletePlan', { RevokePlanList: params }).then(
            (res) => {
              if (res.success) {
                this.$msg(res.message || '删除成功', 'success')
                this.getDataList()
              }
            }
          )
        })
        .catch(() => {})
    },
    reviewPlan(row) {
      this.selectArr = []
      if (row) {
        this.selectArr.push(row)
      } else {
        this.selectArr = this.$refs.table.selection
      }
      this.isReview = true
      this.detailVisible = true
      // let width = window.innerWidth * 0.5
      // let height = window.innerHeight * 0.7
      // this.$dlg.modal(DetailDialog, {
      //   title: '查看改进计划',
      //   width: width,
      //   height: height,
      //   params: {
      //     selectedArr: [row],
      //     Zkjb: this.Zkjb,
      //     isReview: true
      //   },
      //   callback: (data) => {
      //     this.getDataList()
      //   },
      //   cancelCallback: () => {}
      // })
    },
    patchPlan(row) {
      if (row && row.SFDJ == 1) {
        let width = window.innerWidth * 0.5
        let height = window.innerHeight * 0.6
        const key = this.$dlg.modal(ApplyDialog, {
          width: width,
          height: height,
          title: '超期操作申请',
          params: {
            dataList: this.applyDataXf,
            hospCode: this.HospitalCode,
            row,
            sqnr: `${
              '【' +
              (row.ZKJB == 1001
                ? '三级质控'
                : row.ZKJB == 1002
                ? '二级质控'
                : '一级质控' == 1001
                ? '三级质控'
                : row.ZKJB == 1002
                ? '二级质控'
                : '一级质控') +
              '】 ' +
              '【' +
              row.BDMC +
              '】 ' +
              '【' +
              row.KSMC +
              '】 ' +
              '【' +
              row.ZZMC +
              '】 ' +
              this.applyDataXf.CJMC +
              '操作'
            }`
          },
          callback: (data) => {
            this.getDataList(this.listQuery)
          },
          cancelCallback: (data) => {
            this.getDataList(this.listQuery)
          }
        })
      } else {
        this.selectArr = []
        if (row) {
          this.selectArr.push(row)
        } else {
          this.selectArr = this.$refs.table.selection
          if (this.selectArr.some((i) => i.SFDJ === 1)) {
            this.$msg('需要下发申请的数据无法进行批量下发')
            return
          }
          if (this.selectArr.some((i) => i.ZKJB != this.selectArr[0].ZKJB)) {
            this.$msg('不同质控级别的数据无法进行批量下发')
            return
          }
        }
        if (this.selectArr.length === 0) {
          this.$msg('请选择操作数据', 'warning')
        } else {
          this.isReview = false
          this.detailVisible = true
        }
      }
    },
    patchPlanBack(row) {
      let selectArr = []
      if (row) {
        selectArr.push(row)
      } else {
        selectArr = this.$refs.table.selection
      }
      let params = selectArr.map((item) => ({
        Cfxh: item.CFXH,
        Xfxh: item.XFXH,
        Kfxdm: item.KFXDM
      }))
      if (selectArr.length === 0) {
        this.$msg('请选择操作数据', 'warning')
        return
      }
      this.$Confirm(
        row ? '确定要将该条记录撤回吗？' : '确定要将所选中的记录均撤回吗？',
        '提示',
        {
          showCancelButton: true,
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }
      )
        .then(() => {
          this.$requestApi('RevokePlan', { RevokePlanList: params }).then(
            (res) => {
              if (res.success) {
                this.$msg(res.message || '撤回成功', 'success')
                this.getDataList(this.listQuery)
              }
            }
          )
        })
        .catch(() => {})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.option-zoom {
  margin-top: 16px;
  text-align: right;
}
.option-zoom .w-button + .w-button {
  margin-left: 16px;
}
.table-container {
  background-color: white;
}
.tool-container {
  margin-top: 6px;
  margin-bottom: 6px;
}
.search-container {
  background-color: white;
  padding: 10px;
}
.mt-10 {
  width: 100%;
  flex-direction: column;
  .check-result-tabs {
    width: 100%;
  }
  .button-container {
    width: 100%;
    text-align: left;
  }
}
/deep/ .w-table__row {
  td:nth-last-child(2) {
    border-right: none;
  }
}
/deep/ .w-select__tags-text {
  display: inline-block;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .w-tag__close-button.w-icon-close {
  transform: translateY(-7px);
}
/deep/ .wn-table-template__table {
  height: calc(100vh - 150px) !important;
}
</style>
